import { normalizeProjectBadgeChars, resolveProjectBadgeSwatch } from '@/shared/data/projectBadges';
import { r, s, typographyTokens } from '@/theme/tokens';
import { Box } from '@/ui/primitives';
import type { ProjectDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

type ProjectBadgeProps = {
  chars: string;
  color: ProjectDto['badgeColor'];
  disabled?: boolean;
};

export const ProjectBadge = ({
  chars,
  color,
  disabled = false,
}: ProjectBadgeProps): ReactElement => {
  const displayChars = normalizeProjectBadgeChars(chars) || 'P';
  const isCompactText = displayChars.length > 1;

  return (
    <Box
      sx={{
        width: s('2xl'),
        height: s('2xl'),
        borderRadius: r('sm'),
        backgroundColor: disabled ? 'action.disabledBackground' : resolveProjectBadgeSwatch(color),
        color: disabled ? 'text.secondary' : 'common.white',
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'block',
          width: '100%',
          overflow: 'hidden',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          lineHeight: 1,
          fontSize: `${
            isCompactText ? typographyTokens.captionSmall.fontSize : typographyTokens.body.fontSize
          } !important`,
          fontWeight: `${typographyTokens.label.fontWeight} !important`,
          color: 'inherit',
          textTransform: typographyTokens.captionSmall.textTransform,
        }}
      >
        {displayChars}
      </Box>
    </Box>
  );
};
